module.exports = __webpack_public_path__ + "static/averta-regular-b0b9ebccbcf53aae12b447803d10f20d.woff";